import axios from "axios";
import settings from "../../../../utils/settings";

const url = `${settings.accountsUrl}api/admin/stories`;

export const addBackground = (id, page, language, photo) => {
  const formData = new FormData();
  formData.append("language", language);
  formData.append("photo", photo, `background-${id}-${language}`);
  return axios.post(`${url}/${id}/${page}/background`, formData);
};

export const addLogo = (id, page, language, photo) => {
  const formData = new FormData();
  formData.append("language", language);
  formData.append("photo", photo, `logo-${id}-${language}`);
  return axios.post(`${url}/${id}/${page}/logo`, formData);
};



// WEBPACK FOOTER //
// ./src/views/pages/stories/requests/addPhoto.js